module.exports = __webpack_public_path__ + "img/zonggelu-1.3ac50e00.jpg";